import axios from "axios";
import { sanitizeInput } from "../../helpers";

export const searchChats = async ({ offset = 0, limit = 10, query = "" }) => {
  try {
    const sanitized = sanitizeInput(query);
    if (!sanitized) {
      throw new Error("Invalid or empty query");
    }

    const { data } = await axios.post(
      `${process.env.REACT_APP_SPL_URL}/v1/tradegpt/chat-messages/search?limit=${limit}&offset=${offset}`,
      { query: sanitized },
      { withCredentials: true },
    );
    return data;
  }
  catch (error) {
    console.error("Error fetching results", error);
    throw error;
  }
};
